export default "__VITE_ASSET__Clx4gMsC__"